import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Logo from './Logo';
import Icon from '../common/icons/Icon';
import UnitedMileageLogo from './UnitedMileageLogo';

const footerLinks = [
  {
    name: 'Courses',
    route: '/subscription/courses',
  },
  {
    name: 'Library',
    route: '/subscription/library',
  },
  {
    name: 'Profile',
    route: '/subscription/profile',
  },
  {
    name: 'Shop',
    route: 'https://shop.tathatagolf.com',
    external: true,
  },
];

const socialLinks = [
  {
    name: 'Instagram',
    route: 'https://instagram.com/tathatagolf',
  },
  {
    name: 'Twitter',
    route: 'https://twitter.com/tathatagolf',
  },
  {
    name: 'Facebook',
    route: 'https://facebook.com/tathatagolf',
  },
  {
    name: 'YouTube',
    route: 'https://youtube.com/tathatagolf',
  },
];

export default class extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    location: PropTypes.object,
  };

  renderLogo() {
    const { location: { pathname } } = this.props;
    if (pathname === '/trial' || pathname === '/') {
      return (
        <a className="footer__logo" href="https://www.tathatagolf.com">
          <Logo />
        </a>
      );
    }
    if (pathname === '/mileageplus') {
      return (
        <a className="footer__logo" href="https://www.tathatagolf.com">
          <UnitedMileageLogo />
        </a>
      );
    }

    return (
      <Link className="footer__logo" to="/subscription/dashboard">
        <Logo />
      </Link>
    );
  }

  renderNavLink(item) {
    if (item.external) {
      return (
        <a key={item.name} href={item.route} target="_blank" rel="noopener">
          {item.name}
        </a>
      );
    }

    return (
      <NavLink key={item.name} to={item.route} activeClassName="active">
        {item.name}
      </NavLink>
    );
  }

  renderNav() {
    return <nav className="footer__nav">{footerLinks.map(this.renderNavLink)}</nav>;
  }

  renderSocialLink(item) {
    return (
      <a key={item.name} href={item.route} target="_blank" rel="noopener">
        <Icon icon={item.name} />
      </a>
    );
  }

  renderSocial() {
    return <div className="footer__social">{socialLinks.map(this.renderSocialLink)}</div>;
  }

  renderLegal() {
    return (
      <div className="footer__legal">
        <a href="https://tathatagolf.com/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </div>
    );
  }

  renderCopyright() {
    const currentYear = new Date()
      .getFullYear()
      .toString()
      .substr(-2);
    return <div className="footer__copyright">© 20{currentYear} Tathata, LLC. All Rights Reserved.</div>;
  }

  render() {
    return (
      <footer className="footer">
        <div className="container">
          {this.renderLogo()}
          {!this.props.isMobile ? this.renderNav() : null}
          {this.renderSocial()}
          {this.renderLegal()}
          {this.renderCopyright()}
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/Footer.js